export const checkVersion = async (): Promise<string> => {
  const response = await fetch("/meta.json");
  const { version } = await response.json();
  return version;
};
